export const CITY_CONFIG = "city-config"
export const GOOGLE_KEY = "AIzaSyCOXqG-qxfFwkSIZK4A1q1w4bMpdHWqEmw";
export const AW_TRANSANCTION_TYPE="HBB_LEADS"
export const ENTERPRISE="ENTERPRISE"
export const AW_PAYMENT_MODE="HBB_AIRTIME"
export const AIRTIME="AIR_TIME"
export const SERVICE_TYPE="HBB_ODU_AW"
